// /**
//  * @format
//  */

import { AppRegistry, Platform, Text, View } from "react-native";
import App from "./App";
import appJson from "./app.json";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

AppRegistry.registerComponent(appJson.name, () => App);

if (Platform.OS === "web") {
  AppRegistry.runApplication(appJson.name, {
    initialProps: {},
    rootTag: document.getElementById("root"),
  });
}

reportWebVitals();
